import mercado from '../images/mercado.png';
import musicas from '../images/musicas.png';
import times from '../images/times.png';
import login from '../images/tela-login.png';
import partidas from '../images/partidas.png';
import skambooks from '../images/skambooks.png';
import skambooks1 from '../images/skambooks1.png';
import receitas from '../images/receitas.png';
import tela from '../images/tela-classificacao.png';
import digimon from '../images/digimom.png';
import covid from '../images/covid.png';
import rick from '../images/rick-morthy.png';
import solar from '../images/solar.png';
import cart from '../images/cart.png';
import shopper from '../images/test-shopper.png';
import recover from '../images/recover.png';
import create from '../images/create.png';
import transaction from '../images/transaction.png';
import usuario from '../images/usuario.png';
import cashback from '../images/cashback.png';
import blog from '../images/blog.png';
import python from '../images/Flesk.png';
import mario from '../images/mario.png';
import memory from '../images/memory.png';
import delivery from '../images/delivery.png';
import school from '../images/school.png';
import movies from '../images/movies.png';

const data = [
  {
    id: 1,
    title: 'Mercado Livre',
    image: mercado,
    link: 'https://jade-trifle-9cc2b8.netlify.app/'
  },  
  {
    id: 2,
    title: 'Trybe Tunes',
    image: musicas,
    link: 'https://github.com/reinaldoper?tab=repositories'
  },
  {
    id: 3,
    title: 'Times mundiais',
    image: times,
    link: 'https://github.com/reinaldoper/ligasDeTimes'
  },
  {
    id: 4,
    title: 'Trybe futebol',
    image: login,
    link: 'https://github.com/reinaldoper/trybe-futebol-clube'
  },
  {
    id: 5,
    title: 'Trybe futebol',
    image: partidas,
    link: 'https://github.com/reinaldoper/trybe-futebol-clube'
  },
  {
    id: 6,
    title: 'Skambooks',
    image: skambooks,
    link: 'https://github.com/stonefullstm/project-skambooks'
  },
  {
    id: 7,
    title: 'Skambooks',
    image: skambooks1,
    link: 'https://github.com/stonefullstm/project-skambooks'
  },
  {
    id: 8,
    title: 'Projeto Receitas',
    image: receitas,
    link: 'https://effortless-jelly-2a6292.netlify.app/'
  },
  {
    id: 9,
    title: 'Classificacao',
    image: tela,
    link: 'https://github.com/reinaldoper/trybe-futebol-clube'
  },
  {
    id: 10,
    title: 'Digimon',
    image: digimon,
    link: 'https://reinaldoper.github.io/digimonsApi/'
  },
  {
    id: 11,
    title: 'Covid-19',
    image: covid,
    link: 'https://super-sawine-84e189.netlify.app/'
  },
  {
    id: 12,
    title: 'Rick-Morthy',
    image: rick,
    link: 'https://github.com/reinaldoper/theRickMortyApi'
  },
  {
    id: 13,
    title: 'Sistema solar',
    image: solar,
    link: 'https://helpful-duckanoo-fa7037.netlify.app/'
  },
  {
    id: 14,
    title: 'Recover',
    image: recover,
    link: 'https://fluxo-phi.vercel.app/'
  },
  {
    id: 15,
    title: 'Shopping Cart',
    image: cart,
    link: 'https://main--vermillion-boba-e170d1.netlify.app/'
  },
  {
    id: 16,
    title: 'Projeto fullStack',
    image: shopper,
    link: 'https://github.com/reinaldoper/shopper'
  },
  {
    id: 17,
    title: 'usuario',
    image: usuario,
    link: 'https://fluxo-phi.vercel.app/'
  },
  {
    id: 18,
    title: 'created',
    image: create,
    link: 'https://fluxo-phi.vercel.app/'
  },
  {
    id: 19,
    title: 'transaction',
    image: transaction,
    link: 'https://fluxo-phi.vercel.app/'
  },
  {
    id: 20,
    title: 'cashback',
    image: cashback,
    link: 'https://front-conta.vercel.app/',
  },
  {
    id: 21,
    title: 'blog',
    image: blog,
    link: 'https://front-blog-post.vercel.app/'
  },
  {
    id: 22,
    title: 'Flask Python',
    image: python,
    link: 'https://github.com/reinaldoper/traduzo-python'
  },
  {
    id: 23,
    title: 'Mario Bros',
    image: mario,
    link: 'https://reinaldoper.github.io/game-mario/'
  },
  {
    id: 24,
    title: 'Memory game',
    image: memory,
    link: 'https://reinaldoper.github.io/memory-game/'
  },
  {
    id: 25,
    title: 'Delivery',
    image: delivery,
    link: 'https://delivery-reinaldoper.vercel.app/'
  },
  {
    id: 26,
    title: 'Basic school',
    image: school,
    link: 'https://school-basic-reinaldo.netlify.app/'
  },
  {
    id: 27,
    title: 'Movies TMDB',
    image: movies,
    link: 'https://movies-project-gamma.vercel.app/'
  }
]

export default data;